import { CalendarEventsLoaderScenarioId } from '../store/schema/CalendarEventsLoaderScenarioId';
import { shouldShowDeclinedEvents } from 'owa-show-declined-meetings-user-config';

const TimePanelScenarios: CalendarEventsLoaderScenarioId[] = [
    'ConflictsView',
    'TimePanelAgendaCalendarCacheId',
    'TimePanelAgenda_UpNextCalendarCacheId',
];

export function getShowDeclinedMeetingsEnabled(
    scenarioId: CalendarEventsLoaderScenarioId
): boolean {
    // Time Panel scenarios will eventually be supported via a setting specific to Time Panel
    if (TimePanelScenarios.some(scenario => scenario == scenarioId)) {
        return false;
    }
    // all other scenarios respect the Calendar module setting (behind feature flag)
    return shouldShowDeclinedEvents();
}
